export default __webpack_public_path__ + "static/media/bus.06e9f2e0.svg";